import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('telli', { path: '/tudo/v3' });

export default httpInstance;
